import tlm_basic from "../../../../src/uvm/images/tlm_basic_illus.svg";
import * as React from 'react';
export default {
  tlm_basic,
  React
};